import Phaser from 'phaser'
import FallingObject from '../Ui/FallingObject'
import Laser from '../Ui/Laser'
import ScoreLabel from '../Ui/ScoreLabel'
import LifeLabel from '../Ui/LifeLabel'
import PowerPoint from '../Ui/PowerPoint'
import PowerLabel from '../Ui/PowerLabel'
import GrazeLabel from '../Ui/GrazeLabel'
import EnemyLaser from '../Ui/EnemyLaser'
export default class HellBullet extends Phaser.Scene
{
    constructor(){
        super('hell-bullet-scene')
    }
    init() {
        this.player = undefined
        this.backSound = undefined

        //variabel cursor
        this.speed = 600
        this.cursors = undefined
        this.nav_left = false
        this.nav_right = false
        this.nav_up = false
        this.nav_down = false
        this.shoot = false

        //variabel laser
        this.lasers = undefined
        this.lastFired = 0

        //variabel enemy
        this.enemies1 = undefined
        this.enemies2 = undefined
        this.enemies3 = undefined
        this.enemySpeed = 250
        this.enemyLaser1 = undefined
        this.enemyLaser2 = undefined
        this.enemyLaser3 = undefined

        //variabel label
        this.board = undefined
        this.lifeLabel = undefined
        this.scoreLabel = undefined
        this.powerLabel = undefined
        this.grazeLabel = undefined

        //variabel poin
        this.power = undefined
        this.graze = undefined
        this.pointSpeed = 260
        
        
    }
    preload(){
        this.load.image('Background2', 'images/game-bg.png')
        this.load.spritesheet('Board', 'images/Scoreboard.png', {
            frameWidth: 160, frameHeight: 450
        })
        this.load.spritesheet('Life', 'images/Life.png', {
            frameWidth: 50, frameHeight: 50
        })
        this.load.spritesheet('Player', 'images/Reimu Hakurei Frame.png', {
            frameWidth: 50, frameHeight: 50
        })
        this.load.spritesheet('Laser', 'images/Bullet.png', {
            frameWidth: 20, frameHeight: 20
        })
        this.load.spritesheet('Enemy', 'images/Enemy.png', {
            frameWidth: 47, frameHeight: 50
        })
        this.load.spritesheet('Point', 'images/Point.png', {
            frameWidth: 50, frameHeight: 50
        })

        this.load.audio('Backsound', 'music/Yukari Theme.mp3')
    }
    create(){
        this.add.image(643, 465, 'Background2').setScale(5)
        this.board = this.physics.add.staticGroup()
        this.board.create(1090, 460, 'Board')
        .setFrame(1)
        .setScale(2.5)
        .setDepth(2)
        .refreshBody()
        this.player = this.createPlayer()        
        this.physics.add.collider(this.player,this.board)
        this.cursors = this.input.keyboard.createCursorKeys()

        this.backSound = this.sound.add('Backsound')
        var music = {
            loop : true
        }
        this.backSound.play(music)

        this.lasers = this.physics.add.group({
            classType: Laser,
            maxSize: 1000,
            runChildUpdate: true
        })
        this.enemies1 = this.physics.add.group({
            classType : FallingObject,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.enemies2 = this.physics.add.group({
            classType : FallingObject,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.enemies3 = this.physics.add.group({
            classType : FallingObject,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.enemyLaser1 = this.physics.add.group({
            classType : EnemyLaser,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.enemyLaser2 = this.physics.add.group({
            classType : EnemyLaser,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.enemyLaser3 = this.physics.add.group({
            classType : EnemyLaser,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.time.addEvent({
            delay : 500,
            callback : this.spawnEnemy,
            callbackScope : this,
            loop : true
        })
        this.life = this.physics.add.sprite(this.player.x, this.player.y, 'Life')
        .setScale(0.5)
        .setDepth(1)
        this.life.setCollideWorldBounds(true)
        this.scoreLabel = this.createScoreLabel(900, 30, 0).setDepth(3)
        this.lifeLabel = this.createLifeLabel(900, 100, 4).setDepth(3)
        this.powerLabel = this.createPowerLabel(900, 250, 0).setDepth(3)
        this.grazeLabel = this.createGrazeLabel(900, 390, 0).setDepth(3)
        this.physics.add.overlap(
            this.lasers,
            this.enemies1,
            this.hitEnemy,
            null,
            this
        )
        this.physics.add.overlap(
            this.lasers,
            this.enemies2,
            this.hitEnemy,
            null,
            this
        )
        this.physics.add.overlap(
            this.lasers,
            this.enemies3,
            this.hitEnemy,
            null,
            this
        )
       
        this.power = this.physics.add.group({
            classType : PowerPoint,
            maxSize : 1000,
            runChildUpdate : true
        })
        this.graze = this.physics.add.group({
            classType : PowerPoint,
            maxSize : 1000,
            runChildUpdate : true
        })

        this.physics.add.overlap(
            this.player,
            this.power,
            this.hitPower,
            null,
            this
        )
        this.physics.add.overlap(
            this.player,
            this.graze,
            this.hitGraze,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemies1,
            this.decreaseLife,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemies2,
            this.decreaseLife,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemies3,
            this.decreaseLife,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemyLaser1,
            this.decreaseLife2,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemyLaser2,
            this.decreaseLife2,
            null,
            this
        )
        this.physics.add.overlap(
            this.life,
            this.enemyLaser3,
            this.decreaseLife2,
            null,
            this
        )
    }
    update(time) {
        this.movePlayer(this.player, this.life, time)
    }
    createPlayer() {
        const player = this.physics.add.sprite(450, 830, 'Player').setScale(2).setDepth(2)
        player.setCollideWorldBounds(true)

        this.anims.create({
            key: 'Right',
            frames: this.anims.generateFrameNumbers('Player', {start: 1, end: 1}),
            frameRate : 10
        })
        this.anims.create({
            key: 'Left',
            frames: this.anims.generateFrameNumbers('Player', {start: 1, end: 1}),
            frameRate: 10
        })
        this.anims.create({
            key: 'Turn',
            frames: this.anims.generateFrameNumbers('Player', {start: 0, end: 0}),
            frameRate: 10
        })
        return player
    }
    movePlayer(player, life, time) {
        //mengatur kecepatan
        if (this.cursors.shift.isDown) {
            this.speed = 300
        }
        if (this.cursors.shift.isUp) {
            this.speed = 600
        }

        //perintah menembak
        if (this.cursors.space.isDown) {
            this.shoot = true
        }
        if (this.cursors.space.isUp) {
            this.shoot = false
        }

        //cursor gerak
        if (this.cursors.right.isDown && this.player.x <= 900) {
            if (this.cursors.up.isDown && this.player.x <= 855) {
                this.player.setVelocityY(this.speed*-1)
            }
            this.player.setVelocityX(this.speed)
            this.life.setPosition(this.player.x, this.player.y)
            this.player.anims.play('Right', true)
            this.player.setFlipX(false)
        }
        else if (this.cursors.left.isDown) {
            this.player.setVelocityX(this.speed*-1)
            this.life.setPosition(this.player.x, this.player.y)
            this.player.anims.play('Left', true)
            this.player.setFlipX(true)
        }
        else if (this.cursors.up.isDown && this.player.x <= 900) {
            if (this.cursors.right.isDown && this.player.x <= 850) {
                this.player.setVelocityX(this.speed)
            }
            this.player.setVelocityY(this.speed*-1)
            this.life.setPosition(this.player.x, this.player.y)
            this.player.anims.play('Turn', true)
        }
        else if (this.cursors.down.isDown) {
            this.player.setVelocityY(this.speed)
            this.life.setPosition(this.player.x, this.player.y)
            this.player.anims.play('Turn', true)
        }
        else {
            this.player.setVelocityY(0)
            this.player.setVelocityX(0)
            this.life.setPosition(this.player.x, this.player.y)
            this.player.anims.play('Turn')
        }

        //perintah menembak
        if ((this.shoot) && time > this.lastFired) {
            const laser1 = this.lasers.get(0, 0, 'Laser').setFrame(0)
            const laser2 = this.lasers.get(0, 0, 'Laser').setFrame(0)
            const laser3 = this.lasers.get(0, 0, 'Laser').setFrame(0)
            const laser4 = this.lasers.get(0, 0, 'Laser').setFrame(3)
            const laser5 = this.lasers.get(0, 0, 'Laser').setFrame(3)

            if (laser1) {
                laser1.fire(this.player.x, this.player.y)
                this.lastFired = time + 100
            }
            if (this.powerLabel.getScore() >= 40) {
                laser2.fire(this.player.x-25, this.player.y+20)
                laser3.fire(this.player.x+25, this.player.y+20)
            }
            if (this.powerLabel.getScore() >= 80) {
                laser4.setFrame(3)
                laser5.setFrame(3)
                laser4.setVelocityX(this.speed*-1).setFlipX(true)
                laser5.setVelocityX(this.speed)
                if (this.cursors.shift.isDown) {
                    laser4.setVelocityX(0)
                    laser5.setVelocityX(0)
                    laser4.setFrame(1)
                    laser5.setFrame(1)
                }
                laser4.fire(this.player.x-70, this.player.y+70)
                laser5.fire(this.player.x+70, this.player.y+70)
            }
        }
    }
    spawnEnemy1() {
        const config = {
            speed : this.enemySpeed,
            rotation : 0
        }
        const enemy1 = this.enemies1.get(0, 0, 'Enemy', config).setFrame(0)
        const enemyLaser1 = this.enemyLaser1.get(0, 0, 'Laser').setFrame(Phaser.Math.Between(10,15)).setScale(1.5)
        const enemyWidth = enemy1.displayWidth
        const positionX1 = Phaser.Math.Between(enemyWidth, 840)
        const distance = Phaser.Math.Distance.Between(this.player.x, this.player.y, enemy1.x, enemy1.y)
        
        if (enemy1) {
            enemy1.spawn(positionX1)
            enemyLaser1.fire(enemy1.x, enemy1.y)
            enemyLaser1.setVelocityX((this.player.x-enemy1.x)/2)
        }
    }
    spawnEnemy2() {
        const config = {
            speed : this.enemySpeed,
            rotation : 0
        }
        const enemy2 = this.enemies1.get(0, 0, 'Enemy', config).setFrame(1)
        const enemyLaser2 = this.enemyLaser2.get(0, 0, 'Laser').setFrame(Phaser.Math.Between(10,15)).setScale(1.5)
        const enemyWidth = enemy2.displayWidth
        const positionX1 = Phaser.Math.Between(enemyWidth, 840)
        
        if (enemy2) {
            enemy2.spawn(positionX1)
            enemyLaser2.fire(enemy2.x, enemy2.y)
            enemyLaser2.setVelocityX((this.player.x-enemy2.x)/2)
        }
    }
    spawnEnemy3() {
        const config = {
            speed : this.enemySpeed,
            rotation : 0
        }
        const enemy3 = this.enemies1.get(0, 0, 'Enemy', config).setFrame(2).setScale(1.5)
        const enemyLaser3 = this.enemyLaser3.get(0, 0, 'Laser').setFrame(Phaser.Math.Between(10,15)).setScale(1.5)
        const enemyWidth = enemy3.displayWidth
        const positionX1 = Phaser.Math.Between(enemyWidth, 840)
        
        if (enemy3) {
            enemy3.spawn(positionX1)
            enemyLaser3.fire(enemy3.x, enemy3.y)
            enemyLaser3.setVelocityX((this.player.x-enemy3.x)/2)
        }
    }
    spawnEnemy() {
        var random = Math.floor(Math.random()*3)
        if ( random == 1) {
            this.spawnEnemy1()
        }
        else if ( random == 2) {
            this.spawnEnemy2()
        }
        else {
            this.spawnEnemy3()
        }
    }
    createScoreLabel(x, y, score) {
        const style = {fontSize: '40px', fill: '#FFFFFF'}
        const label = new ScoreLabel(this, x, y, score, style)
        
        this.add.existing(label)
        return label
    }
    createLifeLabel(x, y, life) {
        const style = {fontSize: '40px', fill: '#FFFFFF'}
        const label = new LifeLabel(this, x, y, life, style)

        this.add.existing(label)
        return label
    }
    createPowerLabel(x, y, score) {
        const style = {fontSize: '40px', fill: '#FFFFFF'}
        const label = new PowerLabel(this, x, y, score, style)

        this.add.existing(label)
        return label
    }
    createGrazeLabel(x, y, score) {
        const style = {fontSize: '40px', fill: '#FFFFFF'}
        const label = new GrazeLabel(this, x, y, score, style)

        this.add.existing(label)
        return label
    }
    powerPoint(x, y) {
        const config = {
            speed : this.pointSpeed,
            rotation : 0
        }
        const power = this.power.get(0, 0, 'Point', config)
        .setFrame(0)
        .setDepth(2)
        
        if (power) {
            power.spawn(x, y)
        }
    }
    grazePoint(x, y) {
        const config = {
            speed : this.pointSpeed,
            rotation : 0
        }
        const graze = this.graze.get(0, 0, 'Point', config)
        .setFrame(1)
        .setDepth(2)

        if (graze) {
            graze.spawn(x, y)
        }
    }
    hitEnemy(laser, enemy) {
        var random =  Math.floor(Math.random()*2)
        if ( random == 1) {
            this.powerPoint(enemy.x, enemy.y)
        }
        else {
            this.grazePoint(enemy.x, enemy.y)
        }
        laser.erase()
        enemy.die()

        this.scoreLabel.add(2500)
    }
    hitPower(player, power) {
        power.die()
        if (this.powerLabel.getScore() >= 120) {
            return
        }
        this.powerLabel.add(1)
    }
    hitGraze(player, graze) {
        graze.die()
        this.grazeLabel.add(1)
    }
    decreaseLife(life, enemy) {
        enemy.die()
        this.lifeLabel.substract(1)

        if (this.powerLabel.getScore() >= 10) {
            this.powerLabel.substract(10)
        }
        else {
            this.powerLabel.substract(this.powerLabel.getScore())
        }

        if (this.grazeLabel.getScore() >= 10) {
            this.grazeLabel.substract(10)
        }
        else {
            this.grazeLabel.substract(this.grazeLabel.getScore())
        }
        6
        if (this.lifeLabel.getLife() == 0) {
            this.backSound.stop()
            this.scene.start('game-over-scene',
            {score: this.scoreLabel.getScore(), power: this.powerLabel.getScore(), graze: this.grazeLabel.getScore(), life: this.lifeLabel.getLife()})
        }
    }
    decreaseLife2(life, laser) {
        laser.erase()
        this.lifeLabel.substract(1)

        if (this.powerLabel.getScore() >= 10) {
            this.powerLabel.substract(10)
        }
        else {
            this.powerLabel.substract(this.powerLabel.getScore())
        }

        if (this.grazeLabel.getScore() >= 10) {
            this.grazeLabel.substract(10)
        }
        else {
            this.grazeLabel.substract(this.grazeLabel.getScore())
        }
        
        if (this.lifeLabel.getLife() == 0) {
            this.backSound.stop()
            this.scene.start('game-over-scene',
            {score: this.scoreLabel.getScore(), power: this.powerLabel.getScore(), graze: this.grazeLabel.getScore(), life: this.lifeLabel.getLife()})
        }
    }
}